import {gql} from '@apollo/client';

export const GetRaces = gql`
    query GetRaces {
        getRaces {
            raceId
            raceName
            raceDescription
            raceFeatures {
                raceFeatureId
                raceFeatureName
                raceFeatureDesc
            }
        }
    }
`

export const GetSubraces = gql`
    query GetSubraces {
        getSubraces {
            subraceName
            subraceId
            subraceDescription
            Race {
                raceId
                raceName
            }
            subraceFeatures {
                subraceFeatureId
                subraceFeatureName
                subraceFeatureDesc
            }
        }
    }
`

export const GetClasses = gql`
    query GetClasses {
        getClasses {
            subclassLevel
            hitdie
            classSpellCast
            className
            classId
            classDescription
            ClassFeature {
                classFeatureName
                classFeatureId
                classFeatureDesc
                onLevel
            }
        }
    }
`

export const GetSubclasses = gql`
    query GetSubclasses {
        getSubclasses {
            subclassName
            subclassId
            subclassDescription
            subClassSpellCast
            Class {
                className
                classId
            }
            SubclassFeature {
                subclassFeatureId
                subclassFeatureDesc
                subclassFeatureName
                onLevel
            }
        }
    }
`

export const GetMana = gql`
    query GetMana {
        getMana {
            manaMaxSpells
            manaMaxSpellLevel
            manaLevel
            manaId
            manaCantrips
            manaAmount
            Class {
                className
                classId
            }
            Subclass {
                subclassName
                subclassId
            }
        }
    }
`